import axios from 'axios';

export const getApiConfig = () => {
  const config = {
    domain: '',
    url: '',
    ssl: false,
  };

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  if (hostname === 'www.hgstaffingsolutions.com' || hostname === 'hgstaffingsolutions.com') {
    config.url = 'https://api-scsmgt-prod.azurewebsites.net/api';
    config.ssl = true;
    config.domain = 'api-scsmgt-prod.azurewebsites.net';
  } else if (hostname === 'www.spacecoastsrcmgt.com' || hostname === 'spacecoastsrcmgt.com') {
    config.url = 'https://api.spacecoastsrcmgt.com/api';
    config.ssl = true;
    config.domain = 'api.spacecoastsrcmgt.com';
  } else if (hostname.includes('webapphgstaffingsolutions') && hostname.includes('azurewebsites.net')) {
    // Azure Web App hostname (producao)
    config.url = 'https://api.spacecoastsrcmgt.com/api';
    config.ssl = true;
    config.domain = 'api.spacecoastsrcmgt.com';
  } else if (hostname === 'app-scsdev.azureedge.net') {
    config.url = 'https://api-scsmgt-dev.azurewebsites.net/api';
    config.ssl = true;
    config.domain = 'api-scsmgt-dev.azurewebsites.net';
  } else if (hostname === 'app.staffcontrol.cloud') {
    config.url = 'https://api.staffcontrol.cloud/api';
    config.ssl = true;
    config.domain = 'api.staffcontrol.cloud';
  } else {
    config.url = 'http://localhost:5003/api';
    config.domain = 'localhost';
    config.ssl = false;
  }

  return config;
};

// Cria a instância do Axios
export const api = axios.create({
  headers: {
    Accept: '*/*',
  },
});

// Interceptor para definir baseURL dinamicamente baseado no hostname
api.interceptors.request.use((config) => {
  // Se já tiver baseURL definida na request, usa ela
  if (config.baseURL) {
    return config;
  }

  // Detecta URL da API baseado no hostname do site
  config.baseURL = getApiConfig().url;
  return config;
});
